import React, { useMemo, useState } from 'react'
import moment from 'moment-timezone'
import CareInput from 'components/CareInput'
import { useI18n } from 'contexts/AuthContext'

// Mirrors fiton-web's checkBirthDate age bounds
// (web_fitonapp/views/HealthLogin/RenderUserInfo.js's useDateSplit): reject
// anything implying an age over 140 or under 13, with the same two error
// messages. (fiton-web's own comment notes 140 ~= moment().diff('01/01/1900',
// 'years'), hardcoded here the same way.)
const MAX_AGE = 140
const MIN_AGE = 13

// Exported so useAboutYou's isNextButtonEnable can gate on the same rule
// this component displays, instead of duplicating the age math.
export const getBirthdayError = (birthday) => {
  const date = moment(birthday, 'MM/DD/YYYY', true)
  if (!date.isValid() || !date.isBefore(moment())) {
    return 'Please enter the correct birthday'
  }
  const age = moment().diff(date, 'years')
  if (age > MAX_AGE) return 'Please enter the correct birthday'
  if (age < MIN_AGE) return 'You must be 13 years or older to join'
  return ''
}

const BirthdayInput = (props) => {
  const { birthday, setBirthday, focus } = props
  const { i18n } = useI18n()
  const [birthdayOnFocus, setBirthdayOnFocus] = useState(false)
  const [isInitialized, setIsInitialized] = useState(true)

  const birthdayError = useMemo(() => getBirthdayError(birthday), [birthday])

  return (
    <CareInput
      {...{
        inputValue: birthday,
        errorMessage: i18n(birthdayError),
        setInputValue: (value) => {
          let inputValue = value.replace(/[^0-9]/g, '')
          const isDelete = (birthday || '').length > value.length
          if (inputValue.length === 2) {
            if (isDelete) {
              inputValue = `${inputValue.slice(0, 2)}`
            } else {
              inputValue = `${inputValue.slice(0, 2)}/`
            }
          } else if (inputValue.length > 2 && inputValue.length < 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}`
          } else if (inputValue.length === 4) {
            if (isDelete) {
              inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}`
            } else {
              inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(
                2,
                4
              )}/`
            }
          } else if (inputValue.length > 4) {
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(
              2,
              4
            )}/${inputValue.slice(4, 8)}`
          }
          setBirthday(inputValue)
        },
        placeholder: 'mm/dd/yyyy',
        focus: focus,
        className: 'item-right',
        isValid: isInitialized || birthdayOnFocus || !birthdayError,
        type: 'text',
        pattern: '\\d*',
        inputMode: 'numeric',
        onFocus: () => {
          setIsInitialized(false)
          setBirthdayOnFocus(true)
        },
        onBlur: () => {
          setBirthdayOnFocus(false)
        },
      }}
    />
  )
}

export default BirthdayInput
